import React from "react";
import cns from "classnames";
import { useObserver } from "mobx-react";
import { TableCell, TableRow } from "@material-ui/core";
import { AccountMultiple, Check } from "mdi-material-ui";
import { makeStyles } from "@material-ui/core/styles";
import { ConsultantImport_RowFragment as Row } from "@graphql";
import { ThemeType } from "@theme";
import { UserAvatarChip } from "@containers";
import { WithTooltip } from "@components";
import { ImportTableCell } from "./ImportTableCell";

export type ConsultantTableRowProps = {
  rowNum: number;
  row: Row;
};

export function ConsultantTableRow(props: ConsultantTableRowProps) {
  const { row } = props;
  const classes = useStyles({});

  const className = cns({
    [classes.error]: row.Errors.length > 0,
    [classes.disabled]: row.IsDuplicate
  });

  function getErrors(field: string) {
    return row.Errors.filter((x) => x.Column === field).map((x) => x.Message);
  }

  return useObserver(() => (
    <TableRow key={row.RowID} className={className}>
      <TableCell>
        <div className={classes.idCol}>
          <span>{props.rowNum}</span>

          {row.IsDuplicate && (
            <WithTooltip title={`Duplicate of ${row.Duplicate.Name}`}>
              <AccountMultiple fontSize="small" />
            </WithTooltip>
          )}
        </div>
      </TableCell>

      <ImportTableCell align="left" errors={getErrors("firstName")}>
        {row.FirstName}
      </ImportTableCell>

      <ImportTableCell align="left" errors={getErrors("lastName")}>
        {row.LastName}
      </ImportTableCell>

      <ImportTableCell align="left" errors={getErrors("ssn")}>
        {row.SocialSecurityNo || row.SocialSecurityNoSource}
      </ImportTableCell>

      <ImportTableCell align="left" errors={getErrors("HPRNumber")}>
        {row.HPRNumber}
      </ImportTableCell>

      <ImportTableCell align="left" errors={getErrors("isApprovedAuthorization")}>
        {row.isApprovedAuthorization ? <Check /> : null}
      </ImportTableCell>

      <ImportTableCell align="left" errors={getErrors("phone")}>
        {row.Phone}
      </ImportTableCell>

      <ImportTableCell align="left" errors={getErrors("cellPhone")}>
        {row.CellPhone}
      </ImportTableCell>

      <ImportTableCell align="left" errors={getErrors("competitor")}>
        {row.Competitor || row.CompetitorSource}
      </ImportTableCell>

      <ImportTableCell align="left" errors={getErrors("areasOfExpertise")}>
        {row.AreaOfExpertise}
      </ImportTableCell>

      <ImportTableCell align="left">
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span>{row.country}</span>
          <span>{row.city}</span>
          <span>{row.streetName}</span>
          <span>{row.zipCode}</span>
        </div>
      </ImportTableCell>

      <ImportTableCell align="left" errors={getErrors("responsiblePerson")}>
        {row.ResponsiblePerson && (
          <UserAvatarChip size="small" userName={row.ResponsiblePerson.Name} />
        )}

        {!row.ResponsiblePerson && row.ResponsiblePersonSource?.Name}
      </ImportTableCell>
    </TableRow>
  ));
}

const useStyles = makeStyles((theme: ThemeType) => ({
  idCol: {
    ...theme.mixins.childrenMarginRight(8),
    display: "flex",
    alignItems: "center"
  },

  error: {
    background: theme.palette.error.background
  },

  disabled: {
    opacity: 0.5
  }
}));
